<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Nos offres dédiées aux professionnels de l'immobilier
                <span>Sans engagements, Résiliables à tout moment</span>
            </h1>
        </div>

        <div class="col-12">
            <div class="message alert-success" *ngIf="success != '' && success != 'Update'">
                <i class="fa fa-check"></i>
                Votre abonnement {{ success }} est validé.<br/>
                Profitez dès maintenant de toutes les fonctionnalités incluses dans ce forfait.
            </div>

            <div class="message alert-success" *ngIf="success != '' && success == 'Update'">
                <i class="fa fa-check"></i>
                Votre nouveau mode de paiement a été enregistrée.
            </div>

            <div class="message alert-danger" *ngIf="error != ''">
                <i class="fa fa-remove"></i>
                Le paiement à échoué, veuillez ressayer ou <a href="mailto:contact@lybox.fr">nous
                contacter</a>.
            </div>
        </div>

        <div class="col-lg-12">
            <div class="row">
                <div class="col-md-6">
                    <div class="bloc-info row"
                         *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && authenticationService.getTrialDay() > 0">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>Période d'essai</b>
                                <span class="fs-4">Expire dans <b>{{ authenticationService.getTrialDay() | number:'1.0-0' }}
                                    jours</b></span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 fs-3 offers">
                        </div>
                        <div class="col-md-6 col-12">
                            <a *ngIf="user.subscription.status == ''" href="/app/user/plan#plan" class="btn btn-lg d-block">Choisir un forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.subscription.status == 'past_due'">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>{{ user.subscription.plan | titlecase}}</b>
                                <span class="fs-4 text-red">
                                     Le renouvellement de votre abonnement a échoué et vos accès ont été désactivés
                                 </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <a href="mailto:contact@lybox.fr?subject=Erreur de paiement"
                               class="btn btn-lg btn-outline d-block">Contactez nous</a>
                        </div>
                        <div class="col-md-6 col-12">
                            <a (click)="updateCB()" *ngIf="user.payment_method.type != ''" class="btn btn-lg btn-danger float-right d-block">Modifier mon moyen de paiement</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.plan != '' && user.plan != 'trial' && user.pro_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>{{ user.plan | titlecase}}</b>
                                <span class="fs-4"
                                      *ngIf="user.subscription.cancel_date != '01/01/0001' && user.subscription.cancel_date != '01/01/1970'">
                                     Votre abonnement sera résilié le {{ user.subscription.cancel_date }}
                                 </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <a *ngIf="user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970'"
                               [routerLink]="['/app/user/form_delete_plan']"
                               class="btn btn-ghost btn-lg d-block">Résilier</a>
                        </div>
                        <div class="col-md-6 col-12">
                            <a href="mailto:contact@lybox.fr?subject=Modification d'abonnement"
                               class="btn btn-lg d-block">Changer mon forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.subscription.plan == '' && user.plan == '' && user.pro_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Aucun forfait en cours
                            </div>
                        </div>
                        <div class="col-md-6 col-12 fs-2 offers">

                        </div>
                        <div class="col-md-6 col-12">
                            <a href="/app/user/plan#plan"
                               class="btn btn-lg d-block">Choisir mon forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.pro_plan != ''">
                        <div class="col-12">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>Professionnel</b>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="bloc-info row">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-card bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Moyen de paiement
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="infoCb">
                                <a (click)="updateCB()" *ngIf="user.payment_method.type != ''" class="btn btn-lg btn-outline float-right">Modifier</a>

                                <b class="fs-4" *ngIf="user.payment_method.type == ''">
                                    Aucun moyen de paiement enregistré<br/><br/>
                                </b>

                                <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                                    Prélèvement bancaire<br/>
                                </b>
                                <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                                    {{ user.payment_method.type_detail | titlecase }} {{ user.payment_method.last_4 }}<br/>
                                    Expire en {{ user.payment_method.exp_month }}/{{user.payment_method.exp_year}}
                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row d-flex justify-content-around align-items-stretch pricing mt-5">
        <div class="text-center mb-3 col-12">
            <div id="plan" class="duration_choose mb-3">
                <div class="duration {{ duration == 'month' ? 'active' : ''}}" (click)="setDuration('month')">
                    Mensuel
                </div>
                <div class="duration {{ duration == 'year' ? 'active' : ''}}" (click)="setDuration('year')">
                    Annuel
                </div>
            </div>
            <b>
                Sans engagement - Résiliable à tout moment
            </b>
        </div>
        <div class="col-12 position-relative">
            <a [routerLink]="['/app/user/plan']" class="text-center ps-0 see_part">
                <i class="fa fa-arrow-circle-o-left"></i><br/>
                Voir les offres pour investisseurs
            </a>
            <div class="row justify-content-center">
                <div class="col-essentiel">
                    <div class="pricing-light">
                        <h2 class="essentiel pb-3">Chasseur immo</h2>
                        <p class="desc">Pour les chasseurs qui veulent gagner du temps et présenter efficacement les opportunités à leurs clients </p>
                        <b class="price" *ngIf="duration == 'year'">
                            699 €<span class="fs-5"> HT /an</span>
                        </b>
                        <b class="price" *ngIf="duration == 'month'">
                            69 €<span class="fs-5"> HT /mois</span><br/>
                            <p class="fs-4 mb-0">
                                + 299 € HT de frais de mise en service
                            </p>
                        </b>
                        <a class="btn btn-primary {{ duration == 'month' ? 'btn-month-pro' : ''}}"
                           *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                           (click)="planSelect('pro')">
                            <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                            <span [hidden]="loading">Choisir ce forfait</span>
                        </a>
                        <a class="btn btn-outline-primary btn-small" href="https://www.lybox.fr/default_template_T2_RENNES_HD.pdf">
                            <span>Télécharger un exemple de rapport </span>
                        </a>
                        <h4>Fonctionnalités :</h4>
                        <ul class="pricing-features">
                            <li>Toutes les fonctionnalités de LyBox</li>
                            <li>Rapport d’investissement d’PDF à votre image (logo, couleurs ...)
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Générez en un clic un rapport d’investissement professionnel pour vos clients.
Ce rapport présente une analyse pousée du bien (Marché immobilier, rentabilité, patrimoine, fiscalité ...) et se personalise complètement à votre image.
Téléchargez un exemple de rapport pour en savoir plus"></i>
                            </li>
                            <li>Importez vos photos sur chaque annonces</li>
                            <li>Support prioritaire</li>
                        </ul>
                    </div>
                </div>
                <div class="col-expert">
                    <div class="pricing-light">
                        <h2 class="expert pb-3">Licence groupe</h2>
                        <p class="desc">
                            Pour les cabinets de clés en mains qui veulent équiper leurs collaborateurs avec des outils puissants et sur mesure
                        </p>
                        <b class="price">
                            Sur devis
                        </b>

                        <a class="btn btn-primary no-sub-btn" href="mailto:contact@lybox.fr">
                            <span>Contactez nous</span>
                        </a>
                        <h4>Fonctionnalités dans Chasseur immo, et :</h4>
                        <ul class="pricing-features">
                            <li>Facturation centralisée</li>
                            <li>Projets collaboratifs entre chasseurs</li>
                            <li>Formation de vos collaborateurs</li>
                            <li>Accès à notre apport de lead investisseurs<br/><br/></li>
                        </ul>
                    </div>
                </div>
                <div class="col-expert">
                <div class="pricing-light">
                    <h2 class="basique pb-3">API</h2>
                    <p class="desc">
                        Pour les professionnels qui veulent intégrer nos données dans leur CRM et leurs outils internes en temps réel
                    </p>
                    <b class="price">
                        Sur devis
                    </b>
                    <a class="btn btn-primary" href="mailto:contact@lybox.fr">
                        <span>Contactez nous</span>
                    </a>
                    <a class="btn btn-outline-primary btn-small" href="https://api.lybox.fr/api/doc">
                        <span>Documentation API</span>
                    </a>
                    <h4>Fonctionnalités :</h4>
                    <ul class="pricing-features">
                        <li>
                            Annonces dédoublonnées en temps réel (1.500 sources)
                            <i class="fa fa-question-circle ms-2"
                               matTooltipClass="tooltip-button"
                               matTooltip="Recevez en temps réels toutes les annonces immobilières en provenance de 700 sites immobiliers, dont Leboncoin, Seloger, Bien ici ... Annonces dédoublonnées et enrichies avec les historiques de prix."></i>
                        </li>
                        <li>
                            Données immobilières
                            <i class="fa fa-question-circle ms-2"
                               matTooltipClass="tooltip-button"
                               matTooltip="Prix immobilier (par ville, quartier, typologie, nombre de pièces ...) et évolution temporelle depuis 2014, loyers par ville, tension locative. Liste des données disponibles dans notre Documentation API."></i>
                        </li>
                        <li>
                            Données sociodémographiques
                            <i class="fa fa-question-circle ms-2"
                               matTooltipClass="tooltip-button"
                               matTooltip="Plus de 100 données différentes pour chaque ville : Population, taux de chômage, taux d’étudiant, niveau de vie moyen, taux de logements vacants... Liste des données disponibles dans notre Documentation API"></i>
                        </li>
                        <li>
                            Couverture France entière
                        </li>
                        <li>
                            Support téléphonique prioritaire
                        </li>
                    </ul>
                </div>
            </div>
            </div>
        </div>
    </div>

    <section class="container-xl mt-4 pt-4 pt-md-5 pb-md-5 mb-0 pb-0">
        <table class="table table-striped table-hover pricing pricing-full">
            <thead class="princing-head">
            <tr>
                <th scope="col" class="col-6 text-center">
                </th>
                <th scope="col" class="col-2 text-center col-essentiel">
                    <h2 class="fs-4 mb-2 mt-1 essentiel">Chasseur immobilier</h2>
                    <b class="price" *ngIf="duration == 'year'">
                        699 €<span class="fs-5"> HT /an</span>
                    </b>
                    <b class="price" *ngIf="duration == 'month'">
                        69 €<span class="fs-5"> HT /mois</span><br/>
                        <p class="fs-4">
                            + 299 € HT de frais de mise en service
                        </p>
                    </b>
                    <a class="btn btn-sm btn-primary btn mt-3 mb-2"
                       *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                       (click)="planSelect('pro')">
                        <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                        <span [hidden]="loading">Souscrire</span>
                    </a>
                </th>
                <th scope="col" class="col-2 text-center col-expert">
                    <h2 class="fs-4 mb-2 mt-1 expert">Licence groupe</h2>
                    <b class="price">
                        Sur devis
                    </b>
                    <a class="btn btn-sm btn-outline-primary mt-3 mb-2"
                       *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                       href="mailto:contact@lybox.fr">
                        <span [hidden]="loading">Contact</span>
                    </a>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4">
                    <h5>Extension LyBox - Analyse des annonces en direct
                        <i class="fa fa-info-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Extension disponible sur Google Chrome et Mozilla Firefox. Compatible avec Leboncoin, SeLoger, Logic Immo et AvendreAlouer"></i>
                    </h5>
                </th>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse de la liste d'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Pour eviter de devoir ouvrir toute les annonces pendant la recherche, les informations clés sont disponibles directement sur la liste d'annonces (prix au m², nombre d'habitants, taux détudiants ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement simples
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Rendement brut, montant d'emprunt, mensualité de crédit"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement avancés
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Cash-Flow, rendement net"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse de la ville
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Toutes les infos essentielles sur la ville : Nombre d'habitants, taux d'étudiants, taux de chômage, part de locataires, tension locative ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Estimation des prix et des loyers
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Retrouvez les prix de vente et les loyers par type de logement pour toutes les villes"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Historique du prix de l'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="L'algorithme de LyBox trace les prix des annonces sur tous les sites immobiliers et est capable de detecter les annonces supprimées puis remises en ligne. L'outil ultime pour des négociations réussies !"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4">
                    <h5>Moteur de recherche immobilier
                        <i class="fa fa-info-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Moteur de recherche aggregant les annonces de tous le web francais"></i>
                    </h5>
                </th>
                <td class="col-2 col-expert col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Moteur de recherche sur +700 sites immobiliers
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Moteur de recherche multi-plateforme spécial investisseur : possibilité de filtrer sur la rentabilité, le prix au m², le nombre d'habitants, la localisation ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Alertes mails sur les recherches
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Recevez en direct les nouvelles annonces parues sur l'un des 700 sites comptatibles directement dans votre boîte mail, sur toutes vos recherches"></i>
                </th>
                <td class="col-2 col-essentiel"><b>Alertes en direct</b></td>
                <td class="col-2 col-expert"><b>Alertes en direct</b></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement avancés sur vos resultats
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Cash-Flow, rendement net"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Outils de ciblage des villes où investir
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Recherche de ville avancé : possibilité de filtrer sur la rentabilité, le prix au m², le nombre d'habitants, la taux de chomage ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Filtrage avancé des annonces
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Utilisation de plus de 20 filtres différents pour votre recherche"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Recherche de commerces et fonds de commerces
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Ciblez uniquement les murs commerciaux et fonds de commerces"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Personnalisation des indicateurs
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Personnalisation des indicateurs dans les resultats de recherches et les favoris"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>


            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4"><h5>Espace utilisateur - Mes annonces immo
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Possibilité de créer des listes de favoris et d'y enregistrer vos annonces immobilières venant de sites différents dans un format optimisé pour les investisseurs"></i>
                </h5></th>
                <td class="col-2 col-expert col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Nombre de favoris maximum</th>
                <td class="col-2 col-essentiel"><b>Illimité</b></td>
                <td class="col-2 col-expert"><b>Illimité</b></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Personnalisation des colonnes
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Créez vous même votre liste de favoris en affichant les informations qui vous intéresse suivant votre stratégie d'investissement"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Comparatif de projets
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Comparez plusieurs projets ou un même projet avec différents régimes d'imposition"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Suivi de projet
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Checklist et prises de notes pour toute les étapes de vos projets au même endroit, soyez sur de ne rien oublier"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Historique du prix de l'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="L'algorithme de LyBox trace les prix des annonces sur tous les sites immobiliers et est capable de detecter les annonces supprimées puis remises en ligne. L'outil ultime pour des négociations réussies !"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4"><h5>Espace utilisateur - Simulateur avancé</h5></th>
                <td class="col-2 col-expert col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse poussée de la ville
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Analyse en détails de la ville : Evolution des prix, analyse des loyers, commerces, universités, nombre d'entreprises, typologie des logements, taille des ménages ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse poussée du rendement
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Intégration de la totalité des frais liés à l'investissement : TF, gestion par agence, comptabilité, vacances locatives ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Tableur d'estimation travaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Décrivez vos travaux en détails pour connaitre le budget nécéssaire pour votre chantier"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition l'IR, LMNP
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Foncier forfait, foncier réel, LMNP forfait, LMNP réel"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition SCI à l'IS</th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition Pinel et Denormandie</th>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition LMP</th>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Comparatif des régimes fiscaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Choisissez le meilleur régime fiscal pour chaque projet à l'aide du TRI, VAN, Enrichissement, Cash-Flow ..."></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition à la revente
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Calculez l'impôt sur la plus value en fonction de votre situation, votre régime fiscal et l'année de revente"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Calculs en temps réels
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Tous les indicateurs sont actualisés en temps réels, votre temps est précieux"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Différé de remboursement et durée des travaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Prise en compte du différé de crédit, de la durée des travaux et du montant des loyers avant travaux (pour les immeubles par exemple) dans le calcul de l'imposition"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Récapitulatif du projet
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Un récapitulatif simple et précis des chiffres du projet. Idéal pour présenter votre dossier à une banque ou un courtier"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Dashboard personnalisé
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Construisez vous mêmes votre dashboard, optimisé pour votre style d'investissement"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Export PDF
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Exportez votre analyse en format PDF"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" colspan="2" class="ps-4"><h5>Services professionnels</h5></th>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="ps-4">Rapport PDF à votre image (logo, couleurs ...)
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Importer votre logo et vos couleurs sur les exports de produits pour vos clients"></i>
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="ps-4">Support prioritaire
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="ps-4">Facturation centralisée
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus"></td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="ps-4">Partage de listes d'annonces entre collaborateurs
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus"></td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="ps-4">Webinaire d'accompagnement pour vos collaborateurs
                </th>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus"></td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            </tbody>
        </table>
    </section>

    <div class="row pricing d-md-none pricing-menu">
        <div class="col-6 text-center switch-pricing" (click)="switchPricing($event.currentTarget)"
             data-target="col-essentiel">
            <h2 class="text-center fs-6 essentiel">Chasseur immobilier</h2>
            <b class="price" *ngIf="duration == 'year'">
                699 €<span class="fs-5"> HT /an</span>
            </b>
            <b class="price" *ngIf="duration == 'month'">
                69 €<span class="fs-5"> HT /mois</span><br/>
                <p class="fs-4">
                    + 299 € HT de frais de mise en service
                </p>
            </b>
        </div>
        <div class="col-6 text-center active switch-pricing" (click)="switchPricing($event.currentTarget)"
             data-target="col-expert">
            <h2 class="text-center fs-6 expert">Licence groupe</h2>
            <b class="price">
                Sur devis
            </b>
        </div>
    </div>
</div>
